import React, { Component } from "react";
import { Route, withRouter, Switch } from "react-router-dom";
import styled from "styled-components";
import $ from "jquery";
import moment from "moment";

import { currentLanguage } from "helpers";
import WP from "WP";

import Header from "partials/Header";
import routes from "routes";
import ErrorBoundary from "partials/ErrorBoundary";
import DevToolbar from "partials/DevToolbar";
import Backdrop from "partials/Backdrop";

class App extends Component {
  componentDidMount() {
    // fix for internal links created in WP editor
    this.fetchTranslations();
    const self = this;
    document.addEventListener(
      "click",
      function (e) {
        if (e.target.tagName === "A") {
          if (e.target.getAttribute("download")) {
            return;
          }
          const href = e.target.getAttribute("href");
          if (href && href.indexOf(WP.home) !== -1) {
            e.preventDefault();
            let fixedHref = href.replace(WP.home, "");
            if (fixedHref[0] !== "/") fixedHref = "/" + fixedHref;
            self.props.history.push(fixedHref);
          }
        }
      },
      false
    );

    moment.locale(currentLanguage() === "no" ? "nb" : "en-gb");
  }

  _onTransitionEnter() {
    $("#root").scrollTop(0);
  }

  _onTransitionEntered() {}

  fetchTranslations = async () => {
    const res = await fetch(
      process.env.REACT_APP_GET_WP_ENDPOINT + "?lang=en"
    );

    const json = await res.json();
  };

  render() {
    const { location } = this.props;

    if (!WP) return null;
    return (
      <Wrapper>
        <ErrorBoundary for='Header'>
          <Header />
        </ErrorBoundary>

        <Switch location={location}>
          {routes.map((route, i) => {
            const { path, component, exact } = route;

            if (Array.isArray(path))
              return path.map((path, i) => (
                <Route
                  key={i}
                  exact={exact}
                  path={path}
                  component={component}
                />
              ));

            return (
              <Route key={i} exact={exact} path={path} component={component} />
            );
          })}
        </Switch>

        {process.env.NODE_ENV === "development" && <DevToolbar />}

        <Backdrop />
      </Wrapper>
    );
  }
}

export default withRouter(App);

const Wrapper = styled.div`
  position: relative;
  min-height: 100vh;
  @media (max-width: 767px) {
    min-height: auto;
    height: auto;
  }
`;
